import styled from 'styled-components';
import { RalewayFont } from 'constants/fonts';
import { black } from 'constants/colors';

export const ContentSimpleCardWrapper = styled.div`
  width: 15rem;
  display: inline-block;
  vertical-align: top;
  margin-right: 1rem;
  border-radius: 1.5rem;
  overflow: hidden;
  box-shadow: 0px 3px 6px 1px rgba(0, 0, 0, 0.16);
  border: 0.1rem solid #e9e9e9;
  cursor: pointer;

  > .header {
    height: 9.4rem;
    background-size: cover;
    background-color: #eee;
    background-position: 50% 50%;
    background-repeat: no-repeat;
    position: relative;
    .paperbin {
      position: absolute;
      top: 0.5rem;
      left: 0.5rem;
      background: white;
      padding: 0.5rem;
      border-radius: 1rem;
    }
  }

  &.disabled {
    .header {
      filter: grayscale(100%);
    }
  }

  .text_name {
    margin-left: 0.5rem;
  }

  .bodyTop {
    background-color: #fff;
    padding: 1rem;

    > .type {
      font-size: 1.1rem;
      margin-bottom: 0.5rem;
    }

    > .title {
      color: ${black};
      font-family: ${RalewayFont.boldFamily};
      font-size: 1.6rem;
      overflow: hidden;
      height: 1.7rem;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
  }

  .body {
    background-color: #fff;
    padding: 1rem;
    height: 7rem;

    > div {
      color: ${black};
      font-family: ${RalewayFont.regularFamily};
      font-size: 1.1rem;
      line-height: 1.6rem;
      white-space: normal;
      height: 5.5rem;
      display: flex;
      overflow: hidden;
    }
    img {
      height: 2rem;
      margin-right: 0.5rem;
    }
  }

  > .footer {
    background-color: #fff;
    height: 2.4rem;
  }
`;

export const TypePhoto = styled.div`
  background: #2680EB;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
`;



// WEBPACK FOOTER //
// ./src/components/Cards/ContentSimpleCard/components/styles.js